import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import di from "../../di/servicelocator";
import Drawer from "react-bottom-drawer";
import "@frameworks/web/stylesheets/components/dowloadHoldingReports/dowloadHoldingReportsMob.scss";
import SmcasePopupLoaderMob from "../../SMCaseLoadPopup/SmcasePopupLoaderMob";
import SmcasePopupSuccessMob from "../../SMCaseLoadPopup/SmcasePopupSuccessMob";
import SmcasePopupFailMob from "../../SMCaseLoadPopup/SmcasePopupFailMob";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { emailRegex } from "../../../../../utils/regex";
import { useDispatch, useSelector } from "react-redux";
import { enterMail, validMail } from "@domains/utils/commonText";
import { holdingDownloadDate } from "@domains/utils/reportDates";
import { previousDay } from "@domains/utils/reportDates";
import { storeEmailListInSessionStorage } from "@domains/utils/sessionMethods";
import { HOLDING_HIDE_ERROR } from "@frameworks/web/redux/interfaces/Reports/iHoldingReport";
import { HoldingErrorEnum } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import { isLoginSourceEMT, LoginSource, } from "@domains/utils/emtReportCallback";
import EdelRadioButtons from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/EdelRadioButtons";
import { getRadioBtns } from "@frameworks/web/components/Reports/RebrandedReports/constant";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import { EConsolidated } from "@frameworks/web/components/Reports/constant";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
const HoldingReportFormMob = (props) => {
    const webConfig = useContext(WebConfigContext);
    const navigate = useNavigate();
    const { loginSource } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const [startDate, setStartDate] = useState(previousDay);
    const [isVisible, setIsVisible] = React.useState(false);
    const [emailList, setEmailList] = useState([]);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const sessionEmailList = sessionStorage.getItem("emailList");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [PDF_or_Excel, setPDForExcel] = useState(null);
    const [currEmailvalue, setCurrEmailValue] = useState();
    const _calendar = useRef(null);
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const emailStatus = useSelector((state) => state.holdingReport.emailStatus);
    const downloadStatus = useSelector((state) => state.holdingReport.downloadStatus);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginSource !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const defaultEmailId = useSelector((state) => state.accountDetailsReducer.emaildId);
    const showDatePicker = (e) => {
        setIsVisible(true);
        if (_calendar.current) {
            _calendar.current.setOpen(true);
        }
    };
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const closeDrawerDate = () => {
        setIsVisible(false);
    };
    const EmailListUpdate = () => {
        if (emailRegex.test(currEmailvalue) &&
            !emailList.includes(currEmailvalue)) {
            storeEmailListInSessionStorage(currEmailvalue, sessionEmailList, true);
            setEmailList([...emailList, currEmailvalue]);
            setCurrEmailValue("");
            return [...emailList, currEmailvalue];
        }
        return [];
    };
    const openDrawerLoader = React.useCallback(() => props.setShowLoader(true), []);
    const openDrawerDownloadS = React.useCallback(() => props.setDownloadSuccess(true), []);
    const openDrawerFail = React.useCallback(() => props.setDownloadFail(true), []);
    const closeDrawerLoader = React.useCallback(() => props.setShowLoader(false), []);
    const closeDrawerDownloadS = React.useCallback(() => props.setDownloadSuccess(false), []);
    const closeDrawerFail = React.useCallback(() => props.setDownloadFail(false), []);
    const goBack = () => {
        dispatch({
            type: HOLDING_HIDE_ERROR,
            errorType: HoldingErrorEnum.DOWNLOADSTATUS,
        });
        const destination = ".." + getLoginSourceURL(loginSource) + "?reportName=Holding";
        navigate(destination, { replace: true });
    };
    let handleSubmit = (e) => {
        e.preventDefault();
        if (!isLoginSourceEMT(lgnSrc))
            openDrawerLoader();
        let emailFormat, downloadFormat = undefined;
        if (downloadCheck) {
            downloadFormat = {
                date: moment(startDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
            };
            props.setOperation("download");
            if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
                downloadFormat.accodes = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
                downloadFormat.isConsolidated =
                    (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.memberName) === EConsolidated.CONSOLIDATED;
            }
            if (webConfig.passwordProtectedDownloadReports)
                downloadFormat.isPwdProtected = true;
        }
        if (emailCheck) {
            let list = emailList;
            if (emailList.length === 0 && currEmailvalue.length > 3) {
                list = EmailListUpdate();
            }
            emailFormat = {
                toDate: moment(startDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
                emailIds: list,
            };
            if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
                emailFormat.accodes = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
                emailFormat.isConsolidated =
                    (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.memberName) === EConsolidated.CONSOLIDATED;
            }
            props.setOperation("email");
        }
        if (downloadCheck && emailCheck) {
            props.setOperation("email_download");
        }
        di.holdingReport.downloadAndSendReport(emailFormat, downloadFormat);
        if (isLoginSourceEMT(lgnSrc)) {
            goBack();
        }
    };
    useEffect(() => {
        if ((emailStatus.isOpen !== null || downloadStatus.isOpen !== null) &&
            props.showLoader &&
            (emailCheck || downloadCheck)) {
            closeDrawerLoader();
            if ((emailCheck && emailStatus.isOpen === true) ||
                (downloadCheck && downloadStatus.isOpen === true)) {
                openDrawerDownloadS();
            }
            else {
                openDrawerFail();
            }
        }
    }, [emailStatus.isOpen, downloadStatus.isOpen]);
    useEffect(() => {
        if (defaultEmailId && !emailList.includes(defaultEmailId)) {
            let defaultEmailList = [defaultEmailId];
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = defaultEmailList;
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
        else {
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = emailList && emailList.length > 0 ? emailList : [];
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    if (!emailList.includes(emailId))
                        finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
    }, [defaultEmailId, emailCheck]);
    useEffect(() => {
        if (PDF_or_Excel && (emailCheck || downloadCheck)) {
            if (emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && !emailCheck) {
                setSubmitDisabled(true);
            }
            else {
                setSubmitDisabled(false);
            }
        }
        else {
            setSubmitDisabled(false);
        }
    }, [emailCheck, emailList, downloadCheck, PDF_or_Excel]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "customForm mobForm mobForm-new" },
            React.createElement("form", { className: "customFormSection", onSubmit: (e) => handleSubmit(e), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        if (!currEmailvalue && submitDisabled) {
                            handleSubmit(e);
                        }
                    }
                } },
                React.createElement(Link, { to: getLoginSourceURL(loginSource) },
                    React.createElement("div", { className: "d-flex align-items-center mobFormHead" },
                        React.createElement("i", { className: "edel-icon-arrow-left1" }),
                        React.createElement("h1", null, "Download Holdings Reports"))),
                React.createElement("div", null,
                    React.createElement("div", { className: "mobFormWrap mobFormWrap-new" },
                        React.createElement("div", { className: "customFormSection_field dateWrap" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-12 col-lg-12" },
                                    React.createElement("label", { htmlFor: "date", className: "date-label" }, "Date"),
                                    React.createElement("div", { className: "" },
                                        React.createElement("div", { className: "input-group datePickerModal" },
                                            React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(startDate).format("DD-MMM-YY") }),
                                            React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerDate, isVisible: isVisible, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                                                React.createElement("div", null,
                                                    React.createElement("div", { className: "drawer-container" },
                                                        React.createElement("div", { className: "date-container" },
                                                            React.createElement("label", { className: "select-date" }, "Select Date"),
                                                            React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(startDate).format("DD-MMM-YY") })),
                                                        React.createElement(DatePicker, { placeholderText: "dd-mm-yy", dateFormat: "d-MMM-yy", onChange: (date) => setStartDate(date), ref: _calendar, inline: true, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), minDate: holdingDownloadDate, maxDate: previousDay, scrollableYearDropdown: true }),
                                                        React.createElement("a", { className: "btn btn-primary custom_btn custom_btn-new", onClick: () => setIsVisible(false) }, "Apply")))),
                                            React.createElement("a", { className: "input-group-append", onClick: showDatePicker },
                                                React.createElement("span", { className: "change-text" },
                                                    React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                    React.createElement("span", null, "Change")))))))),
                        React.createElement("div", { className: "customFormSection_field radioField holdingpdf-summary-details" },
                            React.createElement(EdelRadioButtons, { parentClass: "", title: "Report Format", selected: PDF_or_Excel, setSelected: setPDForExcel, redioBtns: getRadioBtns(ReportName.HOLDINGS), radioClass: "report-format" })),
                        React.createElement("div", { className: "mailCheckbox" },
                            React.createElement("div", { className: "customFormSection_field checkboxWrap" },
                                React.createElement("label", { htmlFor: "", className: "date-label" }, "Get Report As"),
                                React.createElement("div", { className: "checkbox" },
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", name: "downloadType[]", id: "flexCheckDefault", disabled: (isImpersonated &&
                                                lgnSrc !== "nesttrader" &&
                                                PDF_or_Excel &&
                                                PDF_or_Excel === ReportType.EXCEL) ||
                                                sales_native_app, checked: isImpersonated && PDF_or_Excel === ReportType.EXCEL
                                                ? false
                                                : downloadCheck, onChange: (e) => {
                                                setDownloadCheck(e.target.checked);
                                            }, required: !(downloadCheck || emailCheck) }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckDefault" }, "Download")),
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckChecked", name: "downloadType[]", onChange: (e) => {
                                                // setshowMailInput(e.target.checked);
                                                setEmailCheck(e.target.checked);
                                            }, required: !(downloadCheck || emailCheck) }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckChecked" }, "Email")))),
                            emailCheck && (React.createElement("div", { className: "customFormSection_field mailWrap" },
                                React.createElement("div", { className: "blue_bg blue_bg-new mail" },
                                    emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                        React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                            return (React.createElement("li", { key: idx, className: "mail_label_body_item" },
                                                el,
                                                !sales_native_app && (React.createElement("span", { className: "mail_label_close", onClick: () => {
                                                        setEmailList((emailList) => emailList.filter((_, i) => emailList[i] !== el));
                                                        storeEmailListInSessionStorage(el, sessionEmailList, false);
                                                    } },
                                                    React.createElement("i", { className: "edel-icon-rounded-close" })))));
                                        })))),
                                    !sales_native_app && (React.createElement("div", { className: "mail-input" },
                                        React.createElement("input", { ref: inputRef, type: "email", className: "form-control", disabled: isImpersonated || lgnSrc === "nesttrader", pattern: emailRegex.source, value: currEmailvalue, onChange: (e) => {
                                                setCurrEmailValue(e.target.value);
                                                e.target.setCustomValidity("");
                                                inputRef.current.checkValidity();
                                            }, placeholder: "Enter email address", required: emailCheck && emailList.length === 0, onInvalid: (e) => {
                                                if (e.currentTarget.validity.valueMissing) {
                                                    return e.currentTarget.setCustomValidity(enterMail);
                                                }
                                                if (e.currentTarget.validity.patternMismatch) {
                                                    return e.currentTarget.setCustomValidity(validMail);
                                                }
                                            }, onKeyDown: (e) => {
                                                if (e.key === "Enter" &&
                                                    !isImpersonated &&
                                                    lgnSrc !== "nesttrader") {
                                                    e.preventDefault();
                                                    EmailListUpdate();
                                                    if (inputRef && inputRef.current) {
                                                        inputRef.current.checkValidity();
                                                        inputRef.current.reportValidity();
                                                    }
                                                }
                                            } }),
                                        React.createElement("div", { className: `icon ${(isImpersonated || lgnSrc == "nesttrader") &&
                                                "pe-none user-select-auto"}` },
                                            React.createElement("i", { className: "edel-icon-add", onClick: () => {
                                                    if (!isImpersonated &&
                                                        lgnSrc !== "nesttrader") {
                                                        EmailListUpdate();
                                                        if (inputRef && inputRef.current) {
                                                            inputRef.current.checkValidity();
                                                            inputRef.current.reportValidity();
                                                        }
                                                    }
                                                } }))))))))),
                    !isClientLogin && (React.createElement("div", { className: "mt-3 mb-2" },
                        React.createElement(PANPassword, null))),
                    React.createElement("div", null,
                        React.createElement("button", { className: "btn btn-primary custom_btn custom_btn-new", type: "submit", disabled: !submitDisabled }, "Submit")))),
            React.createElement(Drawer, { isVisible: props.showLoader, onClose: closeDrawerLoader, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                React.createElement(SmcasePopupLoaderMob, { Title: "Holdings", closeDrawer: closeDrawerLoader, pageName: "Holding", messageReactNode: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "update-message" }, "Your request is being processed")) })),
            React.createElement(Drawer, { isVisible: props.downloadSuccess, onClose: closeDrawerDownloadS, duration: 250, hideScrollbars: true, className: `holding-report-success ${!isClientLogin && "not-client-login"} drawer__handle-wrapper` },
                React.createElement(SmcasePopupSuccessMob, { Title: "Holdings", closeDrawer: closeDrawerDownloadS, operation: props.operation, pageName: "Holding", sendBack: true, messageReactNode: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "update-message" }, "Your request was successfully processed.")) })),
            React.createElement(Drawer, { isVisible: props.downloadFail, onClose: closeDrawerFail, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                React.createElement(SmcasePopupFailMob, { closeDrawer: closeDrawerFail, operation: props.operation, pageName: "Holding", sendBack: true })))));
};
export default HoldingReportFormMob;
